import { lazy } from 'react';
// import AddServiceRequest from '../pages/addServiceRequest.page';

// ----------------------------------------------------------------------

const ProductsPage = lazy(() => import('../pages/Products.page'));

// ----------------------------------------------------------------------

const ProductsListRoutes = [
    {
        path: '/educational-products',
        children: [
            { element: <ProductsPage />, layout: 'default', isAuthReq: true, index: true },
            // {
            //     path: '/services/service-request',
            //     element: <AddServiceRequest />,
            //     layout: 'default',
            //     isAuthReq: true,
            // },
        ],
    },
];

export { ProductsListRoutes };
